import clone from 'clone';
import { has, get } from 'lodash-es';
let memo = {};
const hasSame = (object1, object2, path) => {
    return (has(object1, path) &&
        has(object2, path) &&
        get(object2, path) === get(object1, path));
};
function projectFormValuesStateMachine(formsState, action) {
    if (!hasSame(formsState, memo, 'client_id')) {
        formsState.contacts = [];
    }
    memo = clone(formsState);
    return formsState;
}
export default projectFormValuesStateMachine;
